// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Pd2qd","pageTitle":"styles_pageTitle__QlKT3","breadcrumbs":"styles_breadcrumbs__HU5zH"};